export default function ConfirmRemoveModal({ open, user, removing, onClose, onConfirm }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-lg rounded-2xl bg-white shadow-xl border animate-[pop_.16s_ease-out]">
          <div className="p-4 border-b flex items-center justify-between">
            <div className="font-semibold">Remove user access</div>
            <button className="px-2 py-1 rounded-lg hover:bg-gray-100" onClick={onClose}>
              ✕
            </button>
          </div>

          <div className="p-4">
            <div className="text-sm text-slate-700">
              This will remove <span className="font-semibold text-slate-900">{user?.email}</span> from the clinic.
            </div>
            <div className="mt-2 text-xs text-slate-500">They will no longer be able to sign in to this clinic.</div>
          </div>

          <div className="p-4 border-t flex items-center justify-end gap-2">
            <button
              className="px-3 py-2 rounded-xl border hover:bg-slate-50 disabled:opacity-50"
              onClick={onClose}
              disabled={removing}
            >
              Cancel
            </button>
            <button
              className="px-3 py-2 rounded-xl text-white bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 disabled:opacity-50"
              onClick={onConfirm}
              disabled={removing}
            >
              {removing ? "Removing…" : "Remove"}
            </button>
          </div>
        </div>
      </div>

      <style>{`@keyframes pop{from{opacity:0;transform:scale(.98)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}
